import { call, put, select } from 'typed-redux-saga'

import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'
import { HttpStatus } from '@services/base'
import services from '@services'
import { IBiometriaSave } from '@services/postBiometriaDadosWebService'
import { BridgeService } from '@services/bridge'
import { logout } from '@utils/functions'
import { ErroType } from '@utils/types'

import { postBiometriaDadoSave, setBiometricToken } from '../actions'

interface Props {
  payload: {
    callback: (biometricToken: string) => void
  }
  type: string
}

export default function* postBiometriaDadosSaga({ payload }: Props) {
  const appState = yield* select((state: ApplicationState) => state)
  const propostaAntiga = appState.refinanciamento.contratos.contratosSelecionados.map(
    (item) => item.numeroProposta,
  )[0]
  const numeroProposta = String(appState.refinanciamento.proposta.numeroProposta) || propostaAntiga
  const body: IBiometriaSave = {
    proposalCode: numeroProposta ? String(numeroProposta) : '',
    isFullCaptureFlow: true,
  }
  try {
    const service = BridgeService.isBrowser()
      ? services.postBiometriaDadosWebService
      : services.postBiometriaDadosAppService

    const { data } = yield* call(service, body, appState.session.accessToken)

    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'postBiometriaDadosService' }))
    yield put(setBiometricToken(data.biometricToken))
    yield payload.callback(data.biometricToken)
  } catch (error) {
    yield put(setLastServiceResponse({ code: 'ERROR', serviceName: 'postBiometriaDadosService' }))
    const erroTyped = error as ErroType
    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
    } else {
      yield put(
        showError({
          title: 'Ocorreu um erro ao carregar dados para biometria',
          message: 'Por favor tente novamente.',
          actionTitle: 'Tentar Novamente',
          code: StepRefin.ERRO_CARREGAR_DADOS_BIOMETRIA,
          actionCallback: () => postBiometriaDadoSave(payload),
          block: true,
        }),
      )
    }
  }
}
